import React from "react";
import {
  Card, CardContent, Grid
} from '@material-ui/core';
import { withStyles } from '@material-ui/styles';

import I18n from "../../../../../../base/i18n.js.jsx";
import { itemWithKeys } from "../../../../../../utils/utils.js.jsx";
import FormFields from "../../../../../../base/form/form_fields.js.jsx";

import pageStyles from "../../../../../styles/page_styles.js.jsx";
import { infoPageStyles } from "../../../../base_info_page.js.jsx";
import cardStyles from "./card_styles.js";

import { AdminUserModel } from "../../../../../../models/users/admin/user_model.js";

const styles = theme => ({
});

const NotesCard = (props) => {

  const { classes, onItemChanged, errorData } = props;

  const user = props.user || {};

  const formFields = AdminUserModel.formFields({item: user});

  const noteFields = ["note"];

  return (
    <Card className = { classes.card }>
      <CardContent>
        <div className = { classes.cardTitle } >
          { I18n.t("admin.users.user.field_group.notes")}
        </div>
        <FormFields formFields = { formFields.filter(field => noteFields.includes(field.name)) }
                    item = { itemWithKeys(user, noteFields) }
                    errorData = { errorData }
                    onItemChange = { onItemChanged } />
      </CardContent>
    </Card>
  );
}

NotesCard.defaultProps = {
}

export default withStyles(
  (theme) => ({
    ...pageStyles(theme),
    ...infoPageStyles(theme),
    ...cardStyles(theme),
    ...styles(theme)
  }),
  { withTheme: true }
)(NotesCard);
